export const DynamoExceptionClassName = {
  duplicate: 'DynamoDB:ConditionalCheckFailedException'
};
